import { render, staticRenderFns } from "./Building.vue?vue&type=template&id=46b8de80&scoped=true"
import script from "./Building.vue?vue&type=script&lang=js"
export * from "./Building.vue?vue&type=script&lang=js"
import style0 from "./Building.vue?vue&type=style&index=0&id=46b8de80&prod&scoped=true&lang=css"
import style1 from "./Building.vue?vue&type=style&index=1&id=46b8de80&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b8de80",
  null
  
)

export default component.exports